// Copyright (c) 2018 Deere & Company

import t from 'tcomb';

const ExcelLayoutColumn = t.struct({
    id: t.String
}, {
    name: 'ExcelLayoutColumn',
    strict: true
});

export const getDefaultState = () => new ExcelLayoutColumn({
    id: ''
});

export default ExcelLayoutColumn;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/excel-layout-column.js